<div [ngClass]="classTheme">
  <motif-toast
    [variant]="type"
    type="text"
    [isVisible]="show"
    (toastDismissed)="close()"
    [tabIndex]="0"
  >
    <div slot="toast-title">{{ message }}</div>
    @if(content){
    <div slot="toast-supporting-text">
      <p class="content-text">{{ content }}</p>
    </div>
    }
    @if(actionText){
    <div slot="toast-actions">
      <motif-button size="sm" variant="text" type="button" (click)="action()">
        {{ actionText }}
      </motif-button>
    </div>
    }
  </motif-toast>
</div>
